// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chart-tooltip-container-Dc7l5 {
  background-color: var(--color-white);
  padding: 12px 16px;
  border: 1px solid var(--color-neutral-200);
  border-radius: var(--radius-xl);
  box-shadow: var(--shadow-lg);
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.chart-tooltip-label-TQ_P8 {
  color: var(--color-neutral-700);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}

.chart-tooltip-items-Jb8uX {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}

.chart-tooltip-item-EWM_I {
  display: flex;
  align-items: center;
  gap: 8px;
  padding-left: 2px;
}

.chart-tooltip-dot-JKOpF {
  width: 8px;
  height: 8px;
  border-radius: 4px;
}

.chart-tooltip-name-mCsnC {
  color: var(--color-neutral-700);
  font-size: var(--text-sm);
}

.chart-tooltip-value-VDDwe {
  color: var(--color-neutral-700);
  font-size: var(--text-sm);
  font-weight: var(--font-weight-medium);
}
`, "",{"version":3,"sources":["webpack://./../core/src/components/chart-tooltip/chart-tooltip.module.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,kBAAkB;EAClB,0CAA0C;EAC1C,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;AACxC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;EACzB,sCAAsC;AACxC","sourcesContent":[".container {\n  background-color: var(--color-white);\n  padding: 12px 16px;\n  border: 1px solid var(--color-neutral-200);\n  border-radius: var(--radius-xl);\n  box-shadow: var(--shadow-lg);\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n\n.label {\n  color: var(--color-neutral-700);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n\n.items {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.item {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  padding-left: 2px;\n}\n\n.dot {\n  width: 8px;\n  height: 8px;\n  border-radius: 4px;\n}\n\n.name {\n  color: var(--color-neutral-700);\n  font-size: var(--text-sm);\n}\n\n.value {\n  color: var(--color-neutral-700);\n  font-size: var(--text-sm);\n  font-weight: var(--font-weight-medium);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `chart-tooltip-container-Dc7l5`,
	"label": `chart-tooltip-label-TQ_P8`,
	"items": `chart-tooltip-items-Jb8uX`,
	"item": `chart-tooltip-item-EWM_I`,
	"dot": `chart-tooltip-dot-JKOpF`,
	"name": `chart-tooltip-name-mCsnC`,
	"value": `chart-tooltip-value-VDDwe`
};
export default ___CSS_LOADER_EXPORT___;
